<template>
  <div>
    <Breadcrumbs :type="type" :header="title" :url="url" />
    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.bed_title" :error="form.errors.bed_title" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name of Room AccessorIes" required="true" placeholder="i.e " />
          <select-input v-model="form.room_id" :error="form.errors.room_id" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name of Room">
            <option value=null>Select Room</option>
            <option v-for="room in rooms" :key="room.id" :value='room.id'>{{ room.room_title }}</option>
          </select-input>
          <div class="pb-8 pr-6 w-full lg:w-1/2 grid grid-cols-12">
            <text-input v-model="form.icon" :error="form.errors.icon" class="col-span-11" label="Icon"
              placeholder="i.e 1" disabled />
            <vue3-icon-picker v-model="form.icon" class="mt-5" />
          </div>
          <status-toogle-button v-model="form.accessories_type" :error="form.errors.accessories_type"
            label="Is Use as bed" class="pb-8 pr-6 w-full lg:w-1/2 mt-5"></status-toogle-button>
          <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status of Room AccessorIes"
            class="pb-8 pr-6 w-full lg:w-1/2 mt-5"></status-toogle-button>
        </div>
        <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
      </form>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import { ref, toRefs, inject } from 'vue'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Button from '@/Shared/Button'
import FileInput from '@/Shared/FileInput'
import Vue3IconPicker from '@/Shared/components/Vue3IconPicker'
export default {
  props: {
    rooms: Array,
  },
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Breadcrumbs,
    StatusToogleButton,
    Button,
    FileInput,
    Vue3IconPicker
  },
  layout: Layout,
  remember: 'form',
  setup(props) {
    const { rooms } = toRefs(props)
    const form = useForm({
      bed_title: null,
      icon: 'fas fa-upload',
      accessories_type: null,
      room_id: null,
      status: true,
    })

    // const regions = ref([])
    const type = ref('create')
    const title = ref('Room Accessories')
    const url = ref('/backend/room-accessories')
    const createUrl = ref('')
    const swal = inject('$swal')
    const store = () => {
      swal({
        title: 'Are you sure?',
        text: "You want to proceed with this action",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          form.post(`${url.value}`, { forceFormData: true, })
          swal.fire(
            'Added!',
            'Your infomation has been Added.',
            'success'
          )
        }
      });

    }
    return {
      form,
      rooms,
      type,
      title,
      url,
      createUrl,
      store
    }
  }
}
</script>
